function updateResponsiveElements(){
    window.isOnMobile = window.matchMedia( "(max-width: 767px)" ).matches;

    if($('#uploaded_photos li .photo-container').length > 0){
        height = $('#uploaded_photos li .photo-container').width();
        $('li.product-photo .photo-container img').css('max-height', height);
        $('li.product-photo .photo-container').height(height);
        $('#uploaded_photos .upload-product-photo').height(height);
        $.each($('li.product-photo .photo-container img'), function(key, value) {
          if (parseInt($(value).attr('width')) > parseInt($(value).attr('height'))) {
            return $(value).css('width', height);
          }
        });

    }
}

$(document).on('click', '.toggle-hidden-content-btn', function() {
    var container = $(this).closest('.has-hidden-content');
    var hiddenContent = $(this).closest('.has-hidden-content').find('.hidden-content');
    if(hiddenContent.is(':visible')){
        $(this).removeClass('show-less').addClass('show-more');
        hiddenContent.slideUp();
        container.removeClass('expanded').addClass('collapsed')

    } else {
        $(this).removeClass('show-more').addClass('show-less');
        hiddenContent.slideDown();
        container.removeClass('collapsed').addClass('expanded');
    }
});

window.onresize = function(event) {
    updateResponsiveElements();
};

// Expose for cross-module access
window.updateResponsiveElements = updateResponsiveElements;
